const handleMultipleChoiceItemSelect = <T = number>({
  selectedId,
  currentIdList,
  setData,
}: {
  selectedId: T
  currentIdList: T[] | null
  setData: (idList: T[] | null) => void
}) => {
  if (currentIdList?.includes(selectedId)) {
    setData(currentIdList.filter(currentIdListItem => currentIdListItem !== selectedId))
  } else {
    setData([...(currentIdList || []), selectedId])
  }
}

export default handleMultipleChoiceItemSelect
